import React, {Fragment, useEffect, useState} from "react";
import IconCart from "./IconCart";
import getOrder from "../getOrder";
import {EVENT_ON_CART_OPEN, EVENT_ON_ORDER_UPDATE} from "../consts";
import dispatchEvent from "../../components/dispatchEvent";

export default () => {

    const [order, setOrder] = useState(null);

    useEffect(() => {
        if (!order) {
            getOrder().then((order) => {
                setOrder(order);
            });
        }
    })

    window.addEventListener(EVENT_ON_ORDER_UPDATE, (e) => {
        setOrder(e.data);
    });

    return <Fragment>
        {!!(order && order.items.length > 0) && <span className="btn btn--white--solid header__login-btn-cart" onClick={() => {
            dispatchEvent(EVENT_ON_CART_OPEN)
        }}>
            <span className="header__nof-items">{order.total_items}</span>
            <span>My order</span>
            <IconCart />
        </span>}
    </Fragment>

}
